import Hero from "../components/ai-SmallBusiness/hero";
import Scope from "../components/ai-SmallBusiness/scope";
import Background from "../components/ai-SmallBusiness/background";
import HowCanHelp from "../components/ai-SmallBusiness/howWeHelp";
import Apply from "../components/ai-SmallBusiness/apply";
import Footer from "../components/footer/footer";

export default function AISmallBusiness(){
  return(
    <>
    <Hero />
    <Scope />
    <Background />
    <HowCanHelp />
    <Apply />
    <Footer />
    </>
  );
}